export const blockIconsActivitiesWaterNew = (
	<span className='material-symbols-outlined'>water</span>
);
